import { FC, useCallback } from 'react'

import ServiceIntegrationCard from '@/components/service-integration-card'
import { useAPI } from '@/hooks/useAPI'
import useObject from '@/hooks/useObject'
import TwilioIntegration from '@/pages/settings/sms-configuration/twilio/details'
import TwilioSetup from '@/pages/settings/sms-configuration/twilio/form'
import { deleteSMS } from '@/thunks/sms/delete'
import { retrieveSMSConfiguration } from '@/thunks/sms/retrieve'

import Twilio from './twilio.svg?react'

const TwilioConfiguration: FC = () => {
  const [configuration, { wasLoaded, set, clear }] = useObject(retrieveSMSConfiguration, {})
  const [remove] = useAPI(deleteSMS)

  const handleRemove = useCallback(() => {
    remove('twilio')
    clear()
  }, [remove, clear])

  if (!wasLoaded) return null

  return (
    <ServiceIntegrationCard
      title="Twilio"
      description="Text messages will be sent from your Twilio account"
      icon={<Twilio className="w-8 h-8" />}
      iconColor="text-[#F22F46] dark:text-white"
      isConnected={!!configuration}
      setupContent={<TwilioSetup onSetup={set} />}
      manageContent={configuration && <TwilioIntegration twilio={configuration.twilio} onRemove={handleRemove} />}
    />
  )
}

export default TwilioConfiguration
